const NAMESPACE = 'jbp-acknowledgment-status-dialog'

export const ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS = {
  dialog: {
    reopenGroupTitle: `${NAMESPACE}--reopen-group-title`,
    reopenGroupContent: `${NAMESPACE}--reopen-group-content`,
    reopenGroupConfirm: `${NAMESPACE}--reopen-group-confirm`,
    title: `${NAMESPACE}--title`, // Acknowledgment Status — {offering} FY{fYear}
    loadError: `${NAMESPACE}--load-error`, // Failed to load acknowledgment data.
    empty: `${NAMESPACE}--empty`, // No acknowledgment data available.
    resendNotificationTitle: `${NAMESPACE}--resend-notification-title`, // Resend notification
    resendNotificationContent: `${NAMESPACE}--resend-notification-content`, // Send a reminder to {signer}?
    signerFallback: `${NAMESPACE}--signer-fallback`, // this signer
    addPbmByEmailTitle: `${NAMESPACE}--add-pbm-by-email-title`, // Add {typeName}
  },
  common: {
    acknowledgment: `${NAMESPACE}--acknowledgment`, // {typeName} Acknowledgment
    actionMenu: `${NAMESPACE}--action-menu`, // Actions
    addPartnerToSigningList: `${NAMESPACE}--add-partner-to-signing-list`, // Add partner to signing list
    addPbmByEmail: `${NAMESPACE}--add-pbm-by-email`, // Add {typeName} by email
    close: `${NAMESPACE}--close`, // Close
    copyEmail: `${NAMESPACE}--copy-email`, // Copy email
    emailCopied: `${NAMESPACE}--email-copied`, // Copied
    lastMandatoryReason: `${NAMESPACE}--last-mandatory-reason`,
    markAsOptional: `${NAMESPACE}--mark-as-optional`, // Mark as optional
    markAsRequired: `${NAMESPACE}--mark-as-required`, // Mark as required
    noItems: `${NAMESPACE}--no-items`, // No items
    notify: `${NAMESPACE}--notify`, // Notify
    optional: `${NAMESPACE}--optional`, // Optional
    other: `${NAMESPACE}--other`, // Other
    sign: `${NAMESPACE}--sign`, // Sign
    signerFallback: `${NAMESPACE}--signer-label-fallback`, // Signer
    simulate: `${NAMESPACE}--simulate`, // Simulate
    you: `${NAMESPACE}--you`, // You
  },
  footer: {
    summary: `${NAMESPACE}--footer-summary`, // {signedCount} of {totalCount} signed
  },
  table: {
    action: `${NAMESPACE}--table-action`, // Action
    date: `${NAMESPACE}--table-date`, // Date
    email: `${NAMESPACE}--table-email`, // Email
    name: `${NAMESPACE}--table-name`, // Name
    role: `${NAMESPACE}--table-role`, // Role
    status: `${NAMESPACE}--table-status`, // Status
  },
  primaryBanner: {
    awaitingAcknowledgment: `${NAMESPACE}--primary-banner-awaiting-acknowledgment`, // Awaiting acknowledgment: {signer}
    reminderSent: `${NAMESPACE}--primary-banner-reminder-sent`, // Reminder was sent {date}
    signRequired: `${NAMESPACE}--primary-banner-sign-required`, // Your signature is required
  },
  commentDialog: {
    commentLabel: `${NAMESPACE}--comment-dialog-comment-label`, // Comment *
    commentRequired: `${NAMESPACE}--comment-dialog-comment-required`, // Please, enter a comment
    refuseDescription: `${NAMESPACE}--comment-dialog-refuse-description`, // Provide a comment to refuse this acknowledgment.
    refuseTitle: `${NAMESPACE}--comment-dialog-refuse-title`, // Refuse acknowledgment
  },
  notifications: {
    acknowledgmentRefused: `${NAMESPACE}--notification-acknowledgment-refused`, // Acknowledgment refused
    acknowledgmentUpdated: `${NAMESPACE}--notification-acknowledgment-updated`, // Acknowledgment updated
    managerConfirmed: `${NAMESPACE}--notification-manager-confirmed`, // Manager confirmed
    notificationSent: `${NAMESPACE}--notification-sent`, // Notification sent
    requestFailed: `${NAMESPACE}--notification-request-failed`, // Please, try again later. Error: {error}
    signatureCanceled: `${NAMESPACE}--notification-signature-canceled`, // Signature canceled
    signerAdded: `${NAMESPACE}--notification-signer-added`, // Signer added to acknowledgment list
    signerRemoved: `${NAMESPACE}--notification-signer-removed`, // Signer removed from acknowledgment list
    signerUpdated: `${NAMESPACE}--notification-signer-updated`, // Signer updated
  },
  planChanges: {
    dialogTitle: `${NAMESPACE}--plan-changes-dialog-title`, // Acknowledgment Change Details
    periodQuarter: `${NAMESPACE}--plan-changes-period-quarter`, // Q{quarter}
    periodTotal: `${NAMESPACE}--plan-changes-period-total`, // {year} total
  },
} as const
